/* eslint-disable no-unused-vars */
import { ConfirmDialogOptions } from '../ConfirmDialog';

let showConfirmationDialog: ((options: ConfirmDialogOptions) => void) | null =
  null;

export function setShowConfirmationDialog(
  fn: (options: ConfirmDialogOptions) => void
) {
  showConfirmationDialog = fn;
}

export function getShowConfirmationDialog() {
  return showConfirmationDialog;
}
